let site_properties = undefined;

const PathFinder = () => {
    let subdomain;
  
    let hostname = window.location.hostname;
    let hostnamePaths = hostname.split('.');
    subdomain = hostnamePaths[0];
  
    if('localhost' === subdomain || '10' === subdomain) {
        let pageToOpen = localStorage.getItem('website');
        subdomain = pageToOpen? pageToOpen:'carrefour';
    } else if('h1' === subdomain || 'd1' === subdomain) {
        subdomain = 'carrefour';
    }

    return subdomain;
}

const getSiteProperties = () => {
    let path = PathFinder();

    try {
        if(!site_properties) {
            site_properties = require(`./${path}/site_properties`);
        }
        
        return site_properties
    } catch(e) {
        return;
    }

}
  
export {PathFinder, getSiteProperties};
